// extracted by mini-css-extract-plugin
module.exports = {"hidden":"emoji-icon-button_hidden_2P0","disabledIcon":"emoji-icon-button_disabledIcon_VjY"};